<script setup>
import { computed } from 'vue';

const props = defineProps({
  status: { type: String, default: '' },
  suppliers: { type: Object, default: () => ({}) },
  resultCount: { type: Number, default: 0 },
});

const messageKey = computed(() => {
  if (props.status === 'failed') return 'HOTEL_PORTAL.PROGRESS.INTERRUPTED';
  if (props.status === 'queued') return 'HOTEL_PORTAL.PROGRESS.QUEUED';
  if (props.status === 'running') return 'HOTEL_PORTAL.PROGRESS.SEARCHING';
  if (
    Object.values(props.suppliers).some(supplier => supplier.state === 'failed')
  ) {
    return 'HOTEL_PORTAL.PROGRESS.PARTIAL';
  }
  return 'HOTEL_PORTAL.PROGRESS.COMPLETE';
});

const stateKey = state => {
  if (state === 'complete') return 'HOTEL_PORTAL.PROGRESS.SUPPLIER_COMPLETE';
  if (state === 'failed') return 'HOTEL_PORTAL.PROGRESS.SUPPLIER_FAILED';
  return 'HOTEL_PORTAL.PROGRESS.SUPPLIER_SEARCHING';
};
</script>

<template>
  <div
    class="rounded-xl border border-n-weak bg-n-solid-2 p-4"
    role="status"
    aria-live="polite"
  >
    <p class="text-sm text-n-slate-12">
      {{ $t(messageKey, { count: resultCount }) }}
    </p>
    <div class="mt-2 flex flex-wrap gap-3 text-xs text-n-slate-11">
      <span v-for="(supplier, name) in suppliers" :key="name">
        {{ name }}:
        {{ $t(stateKey(supplier.state), { count: supplier.count }) }}
      </span>
    </div>
  </div>
</template>
